import { createContext, useContext } from 'react';

export const CookiePreferencesContext = createContext({
  hasConsent: false,
  openCookiePreferences: () => {},
});

export function useCookiePreferences() {
  return useContext(CookiePreferencesContext);
}
